import { OPEN_DROPDOWN_MENU, CLOSE_DROPDOWN_MENU, TOGGLE_DROPDOWN_MENU } from './constants'

export function openDropdownMenu(name) {
    return {
        type: OPEN_DROPDOWN_MENU,
        data: {
            name,
        },
    }
}

export function closeDropdownMenu(name) {
    return {
        type: CLOSE_DROPDOWN_MENU,
        data: {
            name,
        },
    }
}

export function toggleDropdownMenu(name) {
    return {
        type: TOGGLE_DROPDOWN_MENU,
        data: {
            name,
        },
    }
}
